import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController, NavParams, ToastController, LoadingController, AlertController, ModalController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NoticiaProvider } from 'src/app/services/noticia/noticia';
import { UserProvider } from 'src/app/services/user/user';
import { NoticiaVideosPage } from '../noticia-videos/noticia-videos.page';
import { NoticiaLinksPage } from '../noticia-links/noticia-links.page';
import { NoticiaAudiosPage } from '../noticia-audios/noticia-audios.page';
import { LoginPage } from 'src/app/pages/login/login.page';
import { EnqueteListaPage } from 'src/app/pages/enquete-lista/enquete-lista.page';
import { CultoDetalhesPage } from 'src/app/pages/culto/culto-detalhes/culto-detalhes.page';
import { EventoDetalhesPage } from 'src/app/pages/evento/evento-detalhes/evento-detalhes.page';
import { Share } from '@capacitor/share';
import { Browser } from '@capacitor/browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SafeHtmlPipe } from 'src/app/pipes/safe-html/safe-html';
import { AudioPlayerComponent } from '../audio-player/audio-player';
import { VideoPlayerComponent } from '../video-player/video-player';
import { ImagePipe } from 'src/app/pipes/image/image';
import { LoadingSpinnerComponent } from '../loading/loading-spinner/loading-spinner.component';

declare var instituicaoConstants: { IS_PWA: any; };
@Component({
  selector: 'app-noticia-detalhes',
  templateUrl: './noticia-detalhes.page.html',
  styleUrls: ['./noticia-detalhes.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SafeHtmlPipe,
    TranslateModule,
    AudioPlayerComponent,
    VideoPlayerComponent,
    ImagePipe,
    LoadingSpinnerComponent
  ],
})
export class NoticiaDetalhesPage implements OnInit {
  video: any = "";
  playVideo: boolean = false;
  playingVideo: boolean = false;
  noticia: any = {};
  idNoticia;
  @ViewChild('divNoticia')
  divNoticia!: { nativeElement: HTMLElement; };
  public isPWA: boolean = instituicaoConstants.IS_PWA;
  loaded = false;
  midiaList = [
    {
      key: 'videos',
      label: 'Vídeos',
      icon: 'fas fa-video',
      action: () => this.abrirVideos(),
    },
    {
      key: 'links',
      label: 'Links',
      icon: 'far fa-globe-americas',
      action: () => this.abrirLinks(),
    },
    {
      key: 'audios',
      label: 'Áudios',
      icon: 'fas fa-volume-up',
      action: () => this.openAudios(),
    }
  ];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public noticiaProvider: NoticiaProvider,
    public toastCtrl: ToastController,
    public loadingController: LoadingController,
    public translate: TranslateService,
    public userProvider: UserProvider,
    public alertCtrl: AlertController,
    public modalCtrl: ModalController,
  ) {
    this.idNoticia = navParams.get('id');
  }

  ngOnInit() {
    this.noticiaProvider.getNoticiaById(this.idNoticia).subscribe(data => {
      data.links.forEach((link: { config: string; principal: number; }) => {
        let principal: any = JSON.parse(link.config);
        if (principal.principal == 1) {
          link.principal = 1;
        }
      });

      setTimeout(() => {
        this.noticia = data;
        this.loaded = true;
      }, 1000);
    });
  }

  get midiaDisponivel() {
    return this.midiaList.filter(item => this.noticia[item.key]?.length > 0);
  }

  hasPrincipalLink(): boolean {
    return this.noticia?.links?.some((l: { principal: string | number; }) => l.principal == '1' || l.principal == 1);
  }

  async abrirLinks() {
    var data = { links: this.noticia.links }
    let modalPage = await this.modalCtrl.create({ component: NoticiaLinksPage, componentProps: data });
    modalPage.present();
  }

  async abrirVideos() {
    this.playVideo = false;
    this.playingVideo = false;
    var data = { videos: this.noticia.videos }
    let modalPage = await this.modalCtrl.create({ component: NoticiaVideosPage, componentProps: data });
    modalPage.present();
  }

  async openAudios() {
    this.playVideo = false;
    this.playingVideo = false;
    var data = { audios: this.noticia.audios, image: this.noticia.imagemApp }
    let modalPage = await this.modalCtrl.create({ component: NoticiaAudiosPage, componentProps: data });
    modalPage.present();
  }

  async share() {
    if (this.isPWA) {
      window.open(this.noticia.pwa + '?n=' + this.noticia.token);
    } else {
      await Share.share({
        title: this.noticia.titulo,
        text: this.noticia.subtitulo,
        url: this.noticia.pwa + '?n=' + this.noticia.token,
      });
    }
  }

  play() {
    this.playVideo = true;

    setTimeout(() =>
      this.playingVideo = true
      , 4000);

  }

  public async openLink(link: { target: string; url: any; config: string; }) {
    if (link.target == '_blank') {
      await Browser.open({ url: link.url });

    } else if (link.target == '_system') {
      await Browser.open({ url: link.url });

    } else if (link.target == 'contribua') {
      let contribua: any = JSON.parse(link.config);
      await Browser.open({ url: contribua.link });
    } else if (link.target == 'culto') {
      this.userProvider.isLoggedin().then(async login => {
        if (this.userProvider.isAnonimo() || !login) {
          this.needLogin();
        } else {
          let culto: any = JSON.parse(link.config);
          let data = { idCulto: culto.idCulto, dataInicio: culto.dataInicio, idCultoAgenda: culto.idCultoAgenda, modal: false };
          let modalPage = await this.modalCtrl.create({ component: CultoDetalhesPage, componentProps: data });
          modalPage.present();
        }
      });
    } else if (link.target == 'evento') {
      this.userProvider.isLoggedin().then(async login => {
        if (this.userProvider.isAnonimo() || !login) {
          this.needLogin();
        } else {
          let evento: any = JSON.parse(link.config);
          var data = { id: evento.idEvento }
          let modalPage = await this.modalCtrl.create({ component: EventoDetalhesPage, componentProps: data });
          modalPage.present();
        }
      });

    } else if (link.target == 'enquete') {
      this.userProvider.isLoggedin().then(async login => {
        if (this.userProvider.isAnonimo() || !login) {
          this.needLogin();
        } else {
          let modalPage = await this.modalCtrl.create({ component: EnqueteListaPage });
          modalPage.present();
        }
      });

    }
  }

  async needLogin() {
    let alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant('Necessário Login'),
      message: this.translate.instant('Para utilizar essa funcionalidade é necessário fazer login'),
      buttons: [
        {
          text: this.translate.instant('Cancelar'),
          handler: () => { }
        },
        {
          text: this.translate.instant('Fazer Login'),
          handler: async () => {
            let modalPage = await this.modalCtrl.create({ component: LoginPage, componentProps: { 'mostrarHeader': true } });
            modalPage.present();
          }
        }
      ]
    });

    alert.present();
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
